import React from 'react';
import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';
import Introduction from './components/psg-conf-2025/Introduction';
import PSGConferenceForm from '../../components/forms/PSGConferenceForm';

const PSGOnlineConferenceRoot = styled('div')(({ theme }) => ({}));

const PSGOnlineConference = () => {
    return (
        <Fade in={true}>
            <PSGOnlineConferenceRoot>
                <Introduction />

                <PSGConferenceForm source="online" />
            </PSGOnlineConferenceRoot>
        </Fade>
    );
};

export default PSGOnlineConference;
